import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import {
  CreateAgencyUserCommand,
  GetAgencyUsersByAgencyCommand,
  UpdateAgencyUserCommand,
} from './agency-user.commands';
import {
  CreatedAgencyUserEvent,
  GottenAgencyUsersEvent,
  UpdatedAgencyUserEvent,
} from './agency-user.events';
import { isCode } from '../../../shared/helpers/transaction.helpers';

@Injectable()
export class AgencyUserEffects {
  prefix = 'agency-user';
  createAgencyUserCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateAgencyUserCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAgencyUsersByAgencyCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createAgencyUserCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: CreateAgencyUserCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, CreatedAgencyUserEvent)) {
          response.push(
            CreatedAgencyUserEvent({
              agencyUser: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.updateAgencyUserCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: UpdateAgencyUserCommand,
      prefix: this.prefix,

      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, UpdatedAgencyUserEvent)) {
          response.push(
            UpdatedAgencyUserEvent({
              agencyUser: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
    this.getAgencyUsersByAgencyCommand = sciGuaduaHttpRequestHandler.handleEvent({
      command: GetAgencyUsersByAgencyCommand,
      prefix: this.prefix,
      others: (httpResponse, commandData) => {
        const response = [];
        if (isCode(httpResponse, GottenAgencyUsersEvent)) {
          response.push(
            GottenAgencyUsersEvent({
              agencyUsers: httpResponse.data,
            }),
          );
        }
        return response;
      },
    });
  }
}
